
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 2.464L30.918 30.3H3.082L17 2.464zM6.318 28.3h21.364L17 6.936 6.318 28.3z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M20.8 18.9l-.9-.9-2.9 2.9-2.9-2.9-.9.9 2.9 2.9-2.9 2.9.9.9 2.9-2.9 2.9 2.9.9-.9-2.9-2.9 2.9-2.9z","fill":"#F9A91E"}})])
          )
        }
      }
    